import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {getCategoryPosts} from './_requests'
import {PostModel} from './BlogModels'
import {BlogCard} from './BlogCard'
import {Helmet} from 'react-helmet-async'

const BlogCategory: React.FC = () => {
  const {categorySlug} = useParams<{categorySlug: string}>()
  const [posts, setPosts] = useState<PostModel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true)
        const response = await getCategoryPosts(categorySlug!)
        setPosts(response.data)
      } catch (e) {
        setError('خطا در بارگذاری مقالات')
      } finally {
        setLoading(false)
      }
    }
    fetchPosts()
  }, [categorySlug])

  if (loading) return <div>در حال بارگذاری...</div>
  if (error) return <div className='alert alert-danger'>{error}</div>
  if (!posts.length) return <div>مقاله‌ای در این دسته‌بندی یافت نشد.</div>

  // استخراج اطلاعات دسته‌بندی از اولین پست
  const category = posts[0]?.category

  return (
    <>
      <Helmet>
        <title>{`${category.name} | وبلاگ زنجیره بلوک انرژی`}</title>
        <meta name='description' content={category?.description} />
        <meta property='og:title' content={category?.name} />
        <meta property='og:description' content={category?.description} />
      </Helmet>
      {category && (
        <div className='mb-5'>
          <h1 className='fw-bold mb-2'>{category.name}</h1>
          <div className='text-gray-600'>{category.description}</div>
        </div>
      )}
      <div className='row g-4'>
        {posts.map((post) => (
          <div key={post.id} className='col-12 col-sm-6 col-lg-4'>
            <BlogCard post={post} />
          </div>
        ))}
      </div>
    </>
  )
}

export {BlogCategory}
